"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntervalStats = void 0;
/**
 * Class representing the statistics for a specific interval, implementing the IIntervalStats interface.
 */
class IntervalStats {
    /**
     * Constructs a new instance of IntervalStats.
     * @param {IIntervalStats} The interval stats including timestamp, price change, previous price, and current price.
     */
    constructor({ timestamp, priceChange, previousPrice, currentPrice }) {
        this.timestamp = timestamp;
        this.priceChange = priceChange;
        this.previousPrice = previousPrice;
        this.currentPrice = currentPrice;
    }
    /**
     * Creates a new IntervalStats instance from a JSON object.
     * @param {Partial<IntervalStats>} json Partial JSON object representing interval stats.
     * @returns {IntervalStats} A new IntervalStats instance populated with data from the JSON object.
     */
    static fromJson(json) {
        var _a, _b, _c, _d;
        return new IntervalStats({
            timestamp: (_a = json.timestamp) !== null && _a !== void 0 ? _a : 0,
            priceChange: (_b = json.priceChange) !== null && _b !== void 0 ? _b : 0,
            previousPrice: (_c = json.previousPrice) !== null && _c !== void 0 ? _c : 0,
            currentPrice: (_d = json.currentPrice) !== null && _d !== void 0 ? _d : 0,
        });
    }
    /**
     * Converts the IntervalStats instance to a JSON object.
     * @returns {object} JSON representation of the IntervalStats instance.
     */
    toJson() {
        return {
            timestamp: this.timestamp,
            priceChange: this.priceChange,
            previousPrice: this.previousPrice,
            currentPrice: this.currentPrice,
        };
    }
}
exports.IntervalStats = IntervalStats;
